"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KegSchema = exports.KegInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
exports.KegInitialized = {
    name: '',
    location: '',
    serial: '',
    ml: 0,
    totalMl: 0,
    liters: 0,
    numberOfKegs: 0,
    price: 0,
    discountPrice: 0,
    countInventory: false,
    isInStock: false,
};
exports.KegSchema = joi_1.default.object({
    name: joi_1.default.string()
        .optional()
        .allow('')
        .max(500)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name' }),
    }),
    location: joi_1.default.string()
        .optional()
        .allow('')
        .max(500)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Location' }),
    }),
    serial: joi_1.default.string()
        .optional()
        .allow('')
        .max(500)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Serial' }),
    }),
    numberOfKegs: joi_1.default.number()
        .min(0)
        .max(50000)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Ml' }),
    }),
    liters: joi_1.default.number()
        .min(0)
        .max(200)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Liters' }),
    }),
    price: joi_1.default.number()
        .min(0)
        .max(80000)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Price' }),
    }),
    ml: joi_1.default.number().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Ml' }),
    }),
    totalMl: joi_1.default.number().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Total ml' }),
    }),
    countInventory: joi_1.default.boolean(),
    isInStock: joi_1.default.boolean(),
    discountPrice: joi_1.default.number(),
});
